// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXoksol } from "../../../icons/mono/build/icon-xoksol.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XoksolIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXoksol.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XoksolIcon.displayName = 'XoksolIcon';
}

export default XoksolIcon;